import React from "react";

export const FilterFunnelIcon = ({ width = 20, height = 20, color = "#737387" }) => {
  return (
    <svg
      width={`${width}px`}
      height={`${height}px`}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.1251 3.33314C18.125 2.5278 17.4721 1.875 16.6668 1.875H3.33333C2.52792 1.875 1.875 2.52792 1.875 3.33333V4.65482C1.875 5.0416 2.02864 5.41253 2.30214 5.68602L7.64732 11.0312C7.68639 11.0703 7.70834 11.1233 7.70834 11.1785L7.70833 16.016C7.70833 16.6852 8.16377 17.2685 8.81297 17.4308L10.4796 17.8475C11.4001 18.0776 12.2917 17.3814 12.2917 16.4327L12.2917 11.1785C12.2917 11.1233 12.3136 11.0703 12.3527 11.0312L17.6981 5.68608C17.9717 5.41254 18.1253 5.04152 18.1253 4.65466L18.1251 3.33314ZM16.6668 3.125C16.7818 3.125 16.8751 3.21826 16.8751 3.33331L16.8753 4.65483C16.8753 4.71009 16.8533 4.76309 16.8143 4.80217L11.4688 10.1473C11.1953 10.4208 11.0417 10.7917 11.0417 11.1785L11.0417 16.4327C11.0417 16.5682 10.9143 16.6677 10.7828 16.6348L9.11614 16.2181C9.0234 16.1949 8.95833 16.1116 8.95833 16.016L8.95834 11.1785C8.95834 10.7917 8.80469 10.4208 8.5312 10.1473L3.18602 4.80214C3.14695 4.76307 3.125 4.71008 3.125 4.65482V3.33333C3.125 3.21827 3.21827 3.125 3.33333 3.125H16.6668Z"
        fill={color}
      />
    </svg>
  );
};

export default FilterFunnelIcon;
